import { render, staticRenderFns } from "./importModel.vue?vue&type=template&id=452ba87c"
import script from "./importModel.vue?vue&type=script&lang=js"
export * from "./importModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports